
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns/math-vault",
      function () {
        return require("private-next-pages/campaigns/math-vault/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns/math-vault"])
      });
    }
  